export default __webpack_public_path__ + "static/media/45k.2b2376e6.yaml";